export default __webpack_public_path__ + "static/media/Info.476a5635.svg";